/**
 * @file: pinia存储
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-12-12 14:59:57
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-01-17 11:33:17
 * @FilePath: /console-znzs/new_src/store/index.js
 */
import {createPinia, PiniaVuePlugin} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Vue from 'vue';

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
export default pinia;